<script>
export default {
  name: 'LegacyCustomToggle',
  props: {
    toggleOn: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  emits: ['click', 'update:toggleOn'],
  methods: {
    handleClick(e) {
      if (this.disabled) return
      this.$emit('update:toggleOn', !this.toggleOn)
      this.$emit('click', e)
    },
  },
}
</script>

<template>
  <button
    type="button"
    role="switch"
    :aria-checked="toggleOn"
    :disabled="disabled"
    :class="[
      'relative inline-flex h-5 w-9 items-center rounded-full transition-colors',
      toggleOn ? 'bg-primary' : 'bg-muted',
      disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer',
    ]"
    @click="handleClick"
  >
    <span
      :class="[
        'inline-block h-4 w-4 transform rounded-full bg-white shadow transition-transform',
        toggleOn ? 'translate-x-4' : 'translate-x-0.5',
      ]"
    />
  </button>
</template>
